export type LoginErrorCode =
  | "invalid_credentials"
  | "account_locked"
  | "account_under_deletion"
  | "unknown_error";

export type LoginErrorContent = {
  title: string;
  text: string;
};

export const LOGIN_ERROR_CONTENT_MAP = new Map<
  LoginErrorCode,
  LoginErrorContent
>([
  [
    "invalid_credentials",
    {
      title: "Feil e-post eller passord",
      text: "Ugyldig e-post eller passord. Vennligst prøv igjen.",
    },
  ],
  [
    "account_locked",
    {
      title: "Kontoen er sperret",
      text: "Kontoen din er sperret. Dersom du mener dette er feil kan du kontakte oss for mer informasjon.",
    },
  ],
  [
    "account_under_deletion",
    {
      title: "Kontoen er under sletting",
      text: "Prosessen for å slette kontoen din er i gang. Du vil motta en e-post når slettingen er ferdig.",
    },
  ],
  [
    "unknown_error",
    {
      title: "En ukjent feil oppstod",
      text: "En ukjent feil oppstod under innloggingen. Vennligst prøv igjen senere.",
    },
  ],
]);

export const mapToLoginErrorCode = (error: any): LoginErrorCode => {
  const code = error;

  switch (code) {
    case "auth/wrong-password":
    case "auth/user-not-found":
    case "auth/invalid-credential":
      return "invalid_credentials";

    case "auth/user-banned":
      return "account_locked";
    case "auth/user-deleting":
      return "account_under_deletion";

    default:
      return "unknown_error";
  }
};
